import React from 'react';

export function Checkbox({ id, checked, onCheckedChange, disabled }) {
  return (
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={() => onCheckedChange(!checked)}
      disabled={disabled}
      className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 border-gray-300"
    />
  );
}

export default Checkbox;